import * as Styled from "./AddPhotoButton.styles";

import { Typography } from "@mui/material";
import { useRef } from "react";

type AddPhotoButtonProps = {
  disabled: boolean;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  variant: any;
  showIcon?: boolean;
  textColor?: string;
  textWeight?: number;
};

const AddPhotoButton = ({
    disabled,
    handleFileChange,
    variant,
    showIcon = true,
    textColor = 'black',
    textWeight = 400,
}: AddPhotoButtonProps) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    
    const handleInputClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
            fileInputRef.current.click();
        }
    };
    return (
        <Styled.AddPhotoContainer
            variant={variant}
            onClick={handleInputClick}
            style={{
                ...(disabled
                    ? {
                          pointerEvents: "none",
                          opacity: 0.5,
                      }
                    : {}),
            }}
        >
            {showIcon && <Styled.AddIcon />}
            <Typography style={{ color: textColor, fontWeight: textWeight }}>Add Photo(s)</Typography>
            <input
                type="file"
                multiple
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
                disabled={disabled}
            />
        </Styled.AddPhotoContainer>
    );
};

export default AddPhotoButton;
